module.exports = __webpack_public_path__ + "static/media/vi.cb0ea0b4.png";